var BasePolyResizeMixin = require('./base');

module.exports = {

    resizeStart: BasePolyResizeMixin.resizeStart,

    resizeMove: BasePolyResizeMixin.resizeMove,

    resizeEnd: BasePolyResizeMixin.resizeEnd,

    updateDragPtHandleAndPathOnMove: BasePolyResizeMixin.updateDragPtHandleAndPathOnMove,

    // ( Difference is closing the path )
    updatePath: function() {

        this.el.setPathFromPtsArray( this.currentPts, 1 );

    }

};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/poly/poly.js
 ** module id = 200
 ** module chunks = 0
 **/